var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUploadImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 35,
    viewBox: "0 0 33 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.292 0C16.0654 0.000139007 16.8076 0.307635 17.3545 0.854492L25.8535 9.35449C26.4003 9.90136 26.7079 10.6427 26.708 11.416V17.0078C26.0033 16.8539 25.2714 16.7705 24.5205 16.7705C18.8826 16.7706 14.3125 21.3416 14.3125 26.9795C14.3126 30.2342 15.8375 33.1308 18.21 35H3.375C1.76416 35 0.458008 33.6938 0.458008 32.083V2.91699C0.458008 1.30616 1.76416 0 3.375 0H15.292ZM24.5205 18.958C28.9502 18.9581 32.542 22.5498 32.542 26.9795C32.5418 31.4091 28.9501 34.9999 24.5205 35C20.0909 34.9999 16.5002 31.4091 16.5 26.9795C16.5 22.5497 20.0907 18.9581 24.5205 18.958ZM24.5205 21.875C23.9164 21.875 23.4268 22.3647 23.4268 22.9688V25.8857H20.5098C19.9059 25.8859 19.416 26.3755 19.416 26.9795C19.4162 27.5833 19.906 28.0731 20.5098 28.0732H23.4268V30.9893C23.4268 31.5933 23.9164 32.083 24.5205 32.083C25.1246 32.083 25.6143 31.5933 25.6143 30.9893V28.0732H28.5312C29.1351 28.0731 29.6248 27.5833 29.625 26.9795C29.625 26.3755 29.1352 25.8859 28.5312 25.8857H25.6143V22.9688C25.6143 22.3647 25.1246 21.875 24.5205 21.875Z",
    fill: "#C2C2C2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadImage);
export default __webpack_public_path__ + "static/media/uploadImage.41aec1b0fda544f379da613bae795cd0.svg";
export { ForwardRef as ReactComponent };